/**
*
* Loader
*
*/

( function( ) {
	'use strict';

	const body = document.body;
	const loader = document.querySelector( '.loading-overlay' );

	window.addEventListener( 'load', function () {
		setTimeout( function() {
			loader.classList.remove( 'visible' );
			body.classList.add( 'is-loaded' );
		}, 500 );
	} );

} )();
